
import Animations from './modules/animations';
import Slider from './modules/slider';
import WeCreate from './modules/we-create';
import AnimatedStroke from './modules/animated-stroke';
import ScrollToElement from './modules/scroll-to-element';
import Particles from './modules/particles';
import HeroVideo from "./modules/hero-video";
import ContentToggle from "./modules/content-toggle";
import Showreel from "./modules/showreel";
import ClientsVideo from "./modules/clients-video";
import ClientLogos from "./elements/client-logos";
import WebinarForm from "./elements/webinar-form";
import WhatPeopleSay from "./elements/what-people-say";
import Header from "./modules/header";
import OurWorkTiles from "./elements/our-work-tiles";
import Video from "./modules/video";
import VideoPlayButton from "./modules/video-play-button";
import CountUp from "./modules/count-up";
import RepositionElement from "./modules/reposition-element";


const loader = require('scriptjs');
const libraryPath = window['themeDirectory'] + '/javascript/libraries/';
const dependencies = {
	glide: libraryPath + 'glide.min.js',
	lazysizes: libraryPath + 'lazysizes.min.js',
	particles: libraryPath + 'particles-min.js',
	hls: libraryPath + 'hls.min.js',
	jQuery: libraryPath + 'jquery.min.js',
}

loader(dependencies.lazysizes, 'lazysizes');



Object.create(Header).init();

document.querySelectorAll('.we-create').forEach((element) => {
	Object.create(WeCreate).init(element);
});


const animatedSVGs = document.querySelectorAll('.large-title');
animatedSVGs.forEach(function (animatedSVG) {
	Object.create(AnimatedStroke).init(animatedSVG);
});

Object.create(Animations).init();

const sliders = document.querySelectorAll('.slider');
if (sliders.length) {
	loadCSS(window['themeDirectory'] + '/css/libraries/glide.core.min.css');
	loadCSS(window['themeDirectory'] + '/css/libraries/glide.theme.min.css');
	loader(dependencies.glide, 'glide');
	loader.ready('glide', function () {
		sliders.forEach(function (element) {
			Object.create(Slider).init(element);
		});
	});
}

Object.create(ScrollToElement).init();

if (document.querySelector('.content-toggle-controls')) {
	Object.create(ContentToggle).init();
}


const form = document.querySelector('form.contact-form');
if (form) {
	form.querySelectorAll('.form-control').forEach(i => {
		i.addEventListener('invalid', (e) => {
			e.target.classList.add('invalid');
		});
	});
}

window.onFormSubmit = () => {
	form.querySelectorAll('.form-control').forEach(i => {
		i.classList.remove('invalid');
	});
	if (form.checkValidity()) {
		form.submit();
	}
}

loader('https://www.google.com/recaptcha/api.js', 'recaptcha');


document.querySelector('.g-recaptcha') && loader('https://www.google.com/recaptcha/api.js', 'recaptcha');


const particlesElement = document.getElementById('particles-js');
if (particlesElement) {
	loader(dependencies.particles, 'particles');
	loader.ready('particles', function () {
		Object.create(Particles).init();
	});
}


const heroVideoElement = document.querySelector('.hero-video');
if (heroVideoElement) {
	loader(dependencies.hls, 'hls');
	loader.ready('hls', function () {
		Object.create(HeroVideo).init(heroVideoElement);
	});
}


const showreelHolder = document.querySelector('.showreel');
if (showreelHolder) {
	loader(dependencies.hls, 'hls');
	loader.ready('hls', function () {
		Object.create(Showreel).init(showreelHolder);
	});
}


const clientsVideoHolder = document.querySelector('.clients-video');
if (clientsVideoHolder) {
	Object.create(ClientsVideo).init(clientsVideoHolder);
}


document.querySelectorAll('.client-logos-element')
	.forEach(element => new ClientLogos(element));


document.querySelectorAll('.what-people-say-element')
	.forEach(element => Object.create(WhatPeopleSay).init(element));


document.querySelectorAll('.webinar-registration-form')
	.forEach(element => Object.create(WebinarForm).init(element));


document.querySelectorAll('.our-work-tiles-element')
	.forEach(element => new OurWorkTiles(element));


document.querySelectorAll('.count-up')
	.forEach(element => new CountUp(element));

document.querySelectorAll('.reposition-element')
	.forEach(element => new RepositionElement(element));




Video.init();

document.querySelectorAll('.text-element .video')
	.forEach(element => Object.create(VideoPlayButton).init(element));

function loadCSS(file) {
	const link = document.createElement('link');
	link.href = file;
	link.type = 'text/css';
	link.rel = 'stylesheet';
	document.getElementsByTagName('head')[0].appendChild(link);
}



document.querySelectorAll('.sticky').forEach(el => {
	let queued = false;
	let top = parseFloat(getComputedStyle(el).top);
	top = Number.isNaN(top) ? 0 : top;
	const update = () => {
		const fits = el.offsetHeight + top <= window.innerHeight;
		el.classList.toggle('sticky', fits);
	};
	const onResize = () => {
		if (queued) {
			return;
		}
		queued = true;
		requestAnimationFrame(() => {
			queued = false;
			update();
		});
	}
	const resizeObserver = new ResizeObserver(update);
	resizeObserver.observe(el);
	window.addEventListener('resize', onResize);
	update();
});
